import * as React from 'react'
import FormattedPrice from './FormattedPrice'

type DiscountedPriceProps = {
  // Decimal places for the amounts. Default 0 (whole currency units); the summary bar passes 2.
  fractionDigits?: number
  // Pre-discount price; shown struck-through (muted) before `value` only when higher.
  original?: number | null
  // Discounted (final) price.
  value: number
}

// Inline discount representation: ~~original~~ value, where the discounted value is
// accented in the discount green (#28a745 — the same green spaportal uses for discount
// rows in the admin/PDF, so a saving reads green on every layout regardless of the
// hotel's brand color). When there is no discount it renders just the value,
// byte-for-byte as before.
const DiscountedPrice: React.FunctionComponent<DiscountedPriceProps> = ({
  fractionDigits = 0,
  original,
  value,
}) => {
  const hasDiscount = typeof original === 'number' && original > value

  if (!hasDiscount) {
    return <FormattedPrice fractionDigits={fractionDigits} value={value} />
  }

  return (
    <>
      <span className="text-muted font-normal line-through mr-2">
        <FormattedPrice fractionDigits={fractionDigits} value={original} />
      </span>
      <span className="text-[#28a745]">
        <FormattedPrice fractionDigits={fractionDigits} value={value} />
      </span>
    </>
  )
}

export default DiscountedPrice
